// extracted by mini-css-extract-plugin
export default {"container":"Gp-z","heading":"Hp-z","text":"Ip-z","info":"Jp-z","link":"Kp-z","fullMaxWidth":"Lp-z"};